module.exports = __webpack_public_path__ + "img/lanternes.6de2ba8.png";